import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InsuranceCoveragePackageDTO  {
    _originalTypeClassName = "zERP.BO.InsuranceCoveragePackageDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InsuranceCoveragePackageDTO.translate = translateService;
}
this.Id = null;
this.Fullname = null;
this.InsuranceCoveragePackageDTOKey = null;
this._key = this.InsuranceCoveragePackageDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Fullname:any;
private _InsuranceCoveragePackageDTOKey:any;
get InsuranceCoveragePackageDTOKey(): any {
    return this._InsuranceCoveragePackageDTOKey;
  }
set InsuranceCoveragePackageDTOKey(value: any) {
    this._InsuranceCoveragePackageDTOKey = value;
    this._key = value;
  }

static Assign(icp: any): any{let icpDTO = new Domain.InsuranceCoveragePackageDTO();
icpDTO.Id = icp?.Id;
icpDTO.Fullname = icp?.FullName;
return icpDTO;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InsuranceCoveragePackageDTOKey == null || $this.InsuranceCoveragePackageDTOKey == 0;
            }


}